// This file is auto-generated. Do not edit!

export default [
  {
    symbol: "WXDAI",
    token: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: true,
    aTokenAddress: "0xC9Fe2D32E96Bb364c7d29f3663ed3b27E30767bB",
    stableDebtTokenAddress: "0xab1B62A1346Acf534b581684940E2FD781F2EA22",
    variableDebtTokenAddress: "0x868ADfDf12A86422524EaB6978beAE08A0008F37",
  },
  {
    symbol: "WETH",
    token: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: true,
    aTokenAddress: "0x629D562E92fED431122e865Cc650Bc6bdE6B96b0",
    stableDebtTokenAddress: "0xe21Bf3FB5A2b5Bf7BAE8c6F1696c4B097F5D2f93",
    variableDebtTokenAddress: "0x0aD6cCf9a2e81d4d48aB7db791e9da492967eb84",
  },
  {
    symbol: "wstETH",
    token: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: true,
    aTokenAddress: "0x9Ee4271E17E3a427678344fd2eE64663Cb78B4be",
    stableDebtTokenAddress: "0x0F0e336Ab69D9516A9acF448bC59eA0CE79E4a42",
    variableDebtTokenAddress: "0x3294dA2E28b29D1c08D556e2B86879d221256d31",
  },
  {
    symbol: "GNO",
    token: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: true,
    aTokenAddress: "0x5671b0B8aC13DC7813D36B99C21c53F6cd376a14",
    stableDebtTokenAddress: "0x2f589BADbE2024a94f144ef24344aF91dE21a33c",
    variableDebtTokenAddress: "0xd4bAbF714964E399f95A7bb94B3DeaF22d9F575d",
  },
  {
    symbol: "sDAI",
    token: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: true,
    aTokenAddress: "0xE877b96caf9f180916bF2B5Ce7Ea8069e0123182",
    stableDebtTokenAddress: "0x2cF710377b3576287Be7cf352FF75D4472902789",
    variableDebtTokenAddress: "0x1022E390E2457A78E18AEEE0bBf0E96E482EeE19",
  },
  {
    symbol: "USDC",
    token: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
    usageAsCollateralEnabled: false,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: true,
    aTokenAddress: "0x5850D127a04ed0B4F1FCDFb051b3409FB9Fe6B90",
    stableDebtTokenAddress: "0x40BF0Bf6AECeE50eCE10C74E81a52C654A467ae4",
    variableDebtTokenAddress: "0xBC4f20DAf4E05c17E93676D2CeC39769506b8219",
  },
  {
    symbol: "USDT",
    token: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
    usageAsCollateralEnabled: false,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: true,
    aTokenAddress: "0x08B0cAebE352c3613302774Cd9B82D08afd7bDC4",
    stableDebtTokenAddress: "0x4cB3F681B5e393947BD1e5cAE84764f5892923C2",
    variableDebtTokenAddress: "0x3A98aBC6F46CA2Fc6c7d06eD02184D63C55e19B2",
  },
  {
    symbol: "EURe",
    token: "0xcB444e90D8198415266c6a2724b7900fb12FC56E",
    usageAsCollateralEnabled: false,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: true,
    aTokenAddress: "0x6dc304337BF3EB397241d1889cAE7da638e6e782",
    stableDebtTokenAddress: "0x80F87B8F9c1199e468923D8EE87cEE311690FDA6",
    variableDebtTokenAddress: "0x0b33480d3FbD1E2dBE88c82aAbe191D7473759D5",
  },
  {
    symbol: "USDC.e",
    token: "0x2a22f9c3b484c3629090FeED35F17Ff8F88f76F0",
    usageAsCollateralEnabled: false,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: true,
    aTokenAddress: "0xA34DB0ee8F84C4B90ed268dF5aBbe7Dcd3c277ec",
    stableDebtTokenAddress: "0xC5dfde524371F9424c81F453260B2CCd24936c15",
    variableDebtTokenAddress: "0x397b97b572281d0b3e3513BD4A7B38050a75962b",
  },
] as const
